import { inject, Injectable } from '@angular/core';

import { ConfigStore } from '../config/config.store';

interface GtmWindow extends Window {
  dataLayer: Record<string, unknown>[];
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly configStore = inject(ConfigStore);

  private currentScript: HTMLScriptElement;

  enableGoogleTagManager() {
    const gtmContainerId = this.configStore.state?.analytics?.gtmContainerId;

    if (!gtmContainerId) {
      console.warn('No google tag manager container id found. Environment will not log google analytics.');
      return;
    }

    if (this.currentScript) {
      console.warn('GTM script already loaded in DOM - Aborting...');
    }

    console.log('Logging to Google Analytics - [GTM Container ID]:', gtmContainerId);

    (window as unknown as GtmWindow).dataLayer = (window as unknown as GtmWindow).dataLayer || [];
    (window as unknown as GtmWindow).dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const gtmScript = document.createElement('script');

    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmContainerId}`;

    const firstHeadChild = document.head.childNodes[0];

    document.head.insertBefore(gtmScript, firstHeadChild);
    this.currentScript = gtmScript;
  }

  removeGoogleTagManager() {
    document.head.removeChild(this.currentScript);
    delete (window as unknown as GtmWindow).dataLayer;
    this.currentScript = null;
  }
}
